module.exports = __webpack_public_path__ + "static/media/edly-white-logo.76a76ea9.png";